import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import {
  BrowserRouter as Router,
  Link,
} from 'react-router-dom';

export default class CardComponent extends React.Component {
  render(){
    return(
      <Link to="/portfolio" style={{textDecoration: 'none'}}>
        <Card className={css(styles.Card)}>
          <CardContent>
          <img className={css(styles.imageCard)} src={this.props.img} alt=""/>
            <Typography className={css(styles.titleCard)} color="primary" variant="title">
              {this.props.title}
            </Typography>
            <Typography className={css(styles.CommonTextCard)} color="secondary">
              {this.props.subtitle}
            </Typography>
          </CardContent>
        </Card>
      </Link>
      )
  }
}

// {this.props.contact.name}Development Apps

const styles = StyleSheet.create({
    Card : {
        textAlign: 'center',
        minHeight: 300,
        maxWidth: 250,
        minWidth: 200,
        boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        cursor: 'pointer',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    imageCard : {
        pointerEvents: 'none',
        height: 110,
    },
    titleCard: {
        marginTop: 20,
    },
    CommonTextCard: {
        marginTop: 20,
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/CoolStuff/CardComponent.js